import Menu from './Menu'
import { useEffect } from 'react'
import { CorporateFare, EmojiPeople } from '@mui/icons-material'
import MenuItem from './MenuItem'
import { Stage } from '../config/config'
import { loginWithSSO } from '../auth/auth'

export default function UnauthenticatedSidebarMenu(props = {}) {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Menu>
      <MenuItem toBlank={true} 
        href={Stage === 'prod' 
          ? 'https://myaccess.microsoft.com/@cocacola.onmicrosoft.com#/access-packages/3041b09d-b714-41ec-9b9b-64a2689ba605'
          : 'https://myaccess.microsoft.com/@tccctestko.onmicrosoft.com#/access-packages/16662dc2-99d0-4fd2-8a08-dcffba17e660'}
        title='I Need to Register'
        icon={<EmojiPeople />} />
      <MenuItem 
        onClick={(e) => {loginWithSSO()}}
        title='Login for Internal Users'
        icon={<CorporateFare />} />
    </Menu>
  )
}